<template>
    <a
        :href="data.detailText ? data.detailPageUrl : data.file.link"
        :target="data.detailText ? '_self' : '_blank'"
        class="news-card"
        v-if="data"
    >
        <div class="news-card__img" :style="`background-image: url(${imgSrc})`"></div>
        <div class="news-card__info">
            <date-block class="news-card__date" size="s" :date="data.activeFrom" />
            <p class="news-card__title">
                <span v-html="data.name"></span>
                <tag class="news-card__title-tag" v-if="!data.detailText" theme="gray-dark" rounded>
                    <span>PDF</span>
                </tag>
            </p>
            <div
                class="news-card__tags"
                v-if="
                    (data.category && data.category.length) || data.type.xmlId === 'press-releases'
                "
            >
                <tag
                    v-if="data.type.xmlId === 'press-releases'"
                    class="news-card__tag"
                    theme="peach"
                >
                    <span v-html="data.type.value"></span>
                </tag>
                <tag
                    class="news-card__tag"
                    theme="gray"
                    v-for="(tag, index) in data.category"
                    :key="index"
                >
                    <span v-html="tag.value"></span>
                </tag>
            </div>
        </div>
    </a>
</template>

<script>
export default {
    name: 'news-card',
    props: {
        data: Object
    },
    computed: {
        imgSrc () {
            if (this.data.previewPicture && this.data.previewPicture.link) return this.data.previewPicture.link
            return '/images/news/dummyimage.webp'
        }
    }
}
</script>

<style lang="scss" scoped>
.news-card {
    text-decoration: none;
    display: flex;
    align-items: flex-start;
    width: 100%;

    @include breakpoint(mobile) {
        flex-direction: column;
    }

    &__img {
        width: 33%;
        flex-shrink: 0;
        max-width: 240px;
        min-width: 180px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        @include margin-level(right, S);

        @include breakpoint(mobile) {
            display: none;
        }

        &:after {
            content: '';
            display: block;
            padding-top: 100%;
            width: 100%;
            background-color: $token-colors-black-5;
            position: relative;
            z-index: -1;
        }
    }

    &__info {
        flex-grow: 1;
        @include breakpoint(mobile) {
            @include padding-level(top, S);
        }
    }

    &__title {
        @include typo-level(M);
        font-weight: 500;
        line-height: 1.4;
        display: inline-block;
        padding-right: 45px;
        position: relative;
    }

    &__title-tag {
        display: inline-block;
        vertical-align: middle;
        // position: absolute;
        bottom: 0.3em;
        margin-left: 6px;
    }

    &__tags {
        display: flex;
        flex-wrap: wrap;
        margin-left: -6px;
        margin-right: -6px;
        margin-top: -6px;
    }

    &__date {
        margin-bottom: $token-spacers-2-xs;
    }

    &__tag {
        margin-left: 6px;
        margin-right: 6px;
        margin-top: 6px;
    }
}
</style>
